import React, { Fragment } from 'react'
import {
  Header,
  SecondStepLogo,
  Title,
  Subtitle,
} from './AccountDetailsFirstTimeUserAndPromptToCompleteHeader.styles'
import { domains } from '../../lib/config'
import RegisteredTrademarkIcon from 'components/RegisteredTrademarkIcon'

const AccountDetailsFirstTimeUserAndPromptToCompleteHeader = ({
  isFirstTimeUser,
  promptToComplete,
}) => {
  return (
    <Header data-testid="first-time-user-section">
      <a href="//www.secondstep.org/" id="secondstep-logo">
        <SecondStepLogo
          alt="Second Step logo"
          src={`${domains.CDN_DOMAIN}/assets/img/login/secondstep-logo.svg`}
        />
      </a>
      <Title>
        {isFirstTimeUser && 'Tell us about your school year'}
        {promptToComplete && "Let's make sure your account is up to date"}
      </Title>
      <Subtitle>
        {isFirstTimeUser && (
          <Fragment>
            Answering these questions helps the Second Step
            <RegisteredTrademarkIcon />
            &nbsp;team tailor our communications to you. <br />
            You can change this information in your Account Details any time.
          </Fragment>
        )}
        {promptToComplete && (
          <Fragment>
            Answering these questions helps us tailor program information for
            you.
            <br />
            You can change your preferences in Account Details at any time.
          </Fragment>
        )}
      </Subtitle>
    </Header>
  )
}

export default AccountDetailsFirstTimeUserAndPromptToCompleteHeader



// WEBPACK FOOTER //
// ./src/components/AccountDetailsFirstTimeUserAndPromptToCompleteHeader/AccountDetailsFirstTimeUserAndPromptToCompleteHeader.js